import React, { useEffect, useState, useRef, useCallback } from "react";
import Input from "../../components/controls/input/customInput/CustomInput";
import service from "../../store/services/budgets.service";
import clientService from "../../store/services/clients.service";
import portfolioService from "../../store/services/portfolio.service";
import programService from "../../store/services/programs.service";
import projectService from "../../store/services/projects.service";
import Searchable from "../../components/controls/select/CustomSelect";
import _ from "lodash";
import { apiCall } from "../../store/services/service";
import {
  BASE_URL,
  URL_SEARCH_CLIENT_PORTFOLIO,
} from "../../store/services/URL";
import { ColumnConfigProvider } from "../../components/controls/tables/ColumnConfigProvider";
import { calculatePageSize } from "../../helpers/utils";
import Table from "../../components/controls/tables/Table";
import {
  getAccountCurrency,
  displayDecimalFormatted,
} from "../../utils/systemSettings";
import RichTextEditor from "../../components/richTextEditor/RichTextEditor";
import { generalActions } from "../../store/actions";
import { useDispatch } from "react-redux";
import Skeleton from "react-loading-skeleton";

const Budget = (props) => {
  const {
    portfolioID,
    programID,
    projectID,
    defaultProject,
    defaultProgram,
    defaultPortfolio,
    allBudgets,
    getBudgetsRequest,
    pageLoading,
    loading,
    createBudgetRequest,
    updateBudgetRequest,
    deleteBudgetRequest,
    pagination,
    error,
    overviewType,
    isNoFixedHeight = false,
    redirectionId,
    onRedirectionComplete,
  } = props;
  const setting = JSON.parse(localStorage.getItem("settings"));
  let prevClientId = useRef(null);
  const manualUpdate = useRef({
    client: false,
    portfolio: false,
    program: false,
  });
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [perPageItems] = useState(calculatePageSize());
  const [pageNum, setPageNum] = useState(1);
  const [selectedRow, setSelectedRow] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [initialBudgetCost, setInitialBudgetCost] = useState(0);
  const [initialBudgetTime, setInitialBudgetTime] = useState("");
  const [changeRequestsCost, setChangeRequestsCost] = useState(0);
  const [changeRequestsTime, setChangeRequestsTime] = useState("");
  const [invoiced, setInvoiced] = useState("");
  const [accural, setAccural] = useState("");
  const [pv, setPV] = useState("");
  const [actual, setActual] = useState("");
  const [ev, setEV] = useState("");
  const [etc, setETC] = useState("");
  const [sv, setSV] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [ClientId, setClientId] = useState("");
  const [PortfolioId, setPortfolioId] = useState(portfolioID);
  const [ProgramId, setProgramId] = useState(programID);
  const [ProjectId, setProjectId] = useState(projectID);
  const [clientOptions, setClientOptions] = useState([]);
  const [portfolioOptions, setPortfolioOptions] = useState([]);
  const [programOptions, setProgramOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [isCreate, setIsCreate] = useState(false);
  const [isCreateNewRow, setIsCreateNewRow] = useState(false);
  const [parentType, setParentType] = useState(null);
  const [isHeader, setIsHeader] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteId, setDeletedId] = useState(null);
  const [changeRequest, setChangeRequest] = useState(null);
  const [tableSearch, setTableSearch] = useState(null);
  const [redirectionItem, setRedirectionItem] = useState(null);
  const [hasProcessedRedirection, setHasProcessedRedirection] = useState(false);
  const [forecastTotals, setForecastTotals] = useState({
    totalForecastAllocation: 0,
    totalForecastHours: 0,
    totalForecastHourlyCostRate: 0,
    totalForecastHourlyBillRate: 0,
    totalForecastCost: 0,
    totalForecastBill: 0,
    totalForecastCv: 0,
    totalForecastHv: 0,
  });

  const fetchData = (pageNumber, pageSize, searchTerm, forceClearSearch = false) => {
    const payload = { page: pageNumber ?? pageNum, size: pageSize ?? perPageItems, search: forceClearSearch ? null : (searchTerm ?? tableSearch) };
    payload.parent = parentType || "Budget";

    if (portfolioID) {
      payload.id = portfolioID;
      payload.parent = "Portfolio";
    }

    if (programID) {
      payload.id = programID;
      payload.parent = "Program";
    }

    if (projectID) {
      payload.id = projectID;
      payload.parent = "Project";
    }
    getBudgetsRequest(payload);
  };

  useEffect(() => {
    if (allBudgets && allBudgets.length > 0) {
      if (!overviewType || overviewType === '' || overviewType === "Portfolio") {
        setData((prevData) => {
          const newMap = new Map(
            allBudgets.map((item) => [item.id, item])
          );

          const updatedPrevData = prevData.map((item) =>
            newMap.has(item.id) ? newMap.get(item.id) : item
          );

          const prevDataIds = new Set(prevData.map((item) => item.id));
          const newItems = allBudgets.filter(
            (budget) => !prevDataIds.has(budget.id)
          );

          return [...updatedPrevData, ...newItems].filter((item => item.cashflowLine));
        });
      }
      else {
        setData(allBudgets);
      }

    } else {
      setData([]);
    }
  }, [allBudgets]);

  const [formErrors, setFormErrors] = useState({
    name: "",
    projectId: "",
  });

  const handleAddRow = useCallback(() => {
    setIsCreateNewRow(true);
    fetchData(pagination.TotalPages ?? 1, perPageItems > 10 ? perPageItems - 5 : perPageItems - 3);
  }, []);

  const searchClientHandler = (value) => {
    if (value === "") {
      setClientOptions([]);
      return;
    }
    clientService
      .searchClientsRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setClientOptions(transformedArray);
      })
      .catch(() => {
        setClientOptions([]);
      });
  };

  const searchPortfolioHandler = (value) => {
    if (value === "") {
      setPortfolioOptions([]);
      return;
    }
    const payload = { id: ClientId?.value, searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    if (ClientId)
      queryParam = `?clientId=${payload.id}&searchTerm=${payload.searchText}`;
    apiCall
      .get({
        url: `${URL_SEARCH_CLIENT_PORTFOLIO}${queryParam}`,
        isAuthToken: true,
      })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPortfolioOptions(transformedArray);
      })
      .catch(() => {
        setPortfolioOptions([]);
      });
  };

  const searchProgramHandler = (value) => {
    if (value === "") {
      setProgramOptions([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;

    payload.parent = "Project";

    if (ClientId) {
      queryParam = `?clientId=${ClientId?.value}&searchTerm=${payload.searchText}`;
    }

    if (PortfolioId) {
      queryParam = `?portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && PortfolioId) {
      queryParam = `?clientId=${ClientId.value}&portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Programs${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setProgramOptions(transformedArray);
      })
      .catch(() => {
        setProgramOptions([]);
      });
  };

  const searchProjectHandler = (value) => {
    if (value === "") {
      setProjectOptions([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    payload.parent = "Budget";

    if (ClientId) {
      queryParam = `?clientId=${ClientId?.value}&searchTerm=${payload.searchText}`;
    }

    if (PortfolioId) {
      queryParam = `?portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (ProgramId) {
      queryParam = `?programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && PortfolioId) {
      queryParam = `?clientId=${ClientId.value}&portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && ProgramId) {
      queryParam = `?clientId=${ClientId.value}&programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    if (PortfolioId && ProgramId) {
      queryParam = `?portfolioId=${PortfolioId.value}&programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && PortfolioId && ProgramId) {
      queryParam = `?clientId=${ClientId.value}&portfolioId=${PortfolioId.value}&programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Projects${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          start: obj.startDate,
          end: obj.endDate,
          label: obj.name,
          value: obj.id,
        }));
        setProjectOptions(transformedArray);
      })
      .catch(() => {
        setProjectOptions([]);
      });
  };

  // const searchProgramHandler = (value) => {
  //   if (value === "") {
  //     setProgramOptions([]);
  //     return;
  //   }
  //   // if (value) {
  //   const payload = {
  //     searchText: value,
  //   };
  //   payload.parent = "Project";
  //   if (ClientId) {
  //     payload.id = ClientId.value;
  //     payload.parent = "Client";
  //   }
  //   if (programID) {
  //     payload.id = programID;
  //     payload.parent = "Program";
  //   }
  //   if (portfolioID) {
  //     payload.id = portfolioID;
  //     payload.parent = "Portfolio";
  //   }

  //   projectService
  //     .searchProgramsDataRequest(payload)
  //     .then((res) => {
  //       const transformedArray = res.map((obj) => ({
  //         label: obj.name,
  //         value: obj.id,
  //       }));
  //       setProgramOptions(transformedArray);
  //     })
  //     .catch(() => {
  //       setProgramOptions([]);
  //     });
  //   // }
  // };

  // const searchProjectHandler = (value) => {
  //   if(value === '') {
  //     setProjectOptions([]);
  //     return;
  //   }
  //   // if (value) {
  //     const payload = {
  //       searchText: value,
  //     };

  //     payload.parent = "Budget";
  //     if (programID) {
  //       payload.id = programID;
  //       payload.parent = "Program";
  //     }
  //     if (projectID) {
  //       payload.id = projectID;
  //       payload.parent = "Project";
  //     }
  //     if (portfolioID) {
  //       payload.id = portfolioID;
  //       payload.parent = "Portfolio";
  //     }

  //     projectService
  //       .searchProjectsRequest(payload)
  //       .then((res) => {
  //         const transformedArray = res.map((obj) => ({
  //           start: obj.startDate,
  //           end: obj.endDate,
  //           label: obj.name,
  //           value: obj.id,
  //         }));
  //         setProjectOptions(transformedArray);
  //       })
  //       .catch(() => {
  //         setProjectOptions([]);
  //       });
  //   // } else {
  //   //   setProjectOptions([]);
  //   // }
  // };

  const handleDelete = (selectedRow) => {
    // const id = JSON.parse(localStorage.getItem("selectedRow")).id;
    const id = selectedRow.id;
    if (projectID) {
      deleteBudgetRequest({ id: id, parentID: projectID, parent: "Project" });
      return;
    }
    if (programID) {
      deleteBudgetRequest({ id: id, parentID: programID, parent: "Program" });
      return;
    }
    if (portfolioID) {
      deleteBudgetRequest({
        id: id,
        parentID: portfolioID,
        parent: "Portfolio",
      });
      return;
    }
    deleteBudgetRequest({ id: id, parent: "Budget" });
    setDeletedId(id);
    // localStorage.removeItem("selectedRow");
  };

  const handleSave = () => {
    if (!projectID) {
      if (!ProjectId) {
        dispatch(
          generalActions.showToast({
            title: "The Project field is required.",
            type: "error",
          })
        );
        return;
      }
    }
    setIsEdit(false);
    const payload = {
      ProjectId: projectID ? projectID : ProjectId?.value,
      name,
      code,
      initialBudgetCost: initialBudgetCost || 0,
      initialBudgetTime: initialBudgetTime || 0,
      changeRequestsCost: changeRequestsCost || 0,
      changeRequestsTime: changeRequestsTime || 0,
      pv: pv || 0,
      ev: ev || 0,
      etc: etc || 0,
    };
    if (Object.keys(selectedRow).length > 0) {
      if (projectID) {
        updateBudgetRequest({
          id: selectedRow.id,
          parentID: projectID,
          parent: "Project",
          payload,
        });
        return;
      }
      if (programID) {
        updateBudgetRequest({
          id: selectedRow.id,
          parentID: programID,
          parent: "Program",
          payload,
        });
        return;
      }
      if (portfolioID) {
        updateBudgetRequest({
          id: selectedRow.id,
          parentID: portfolioID,
          parent: "Portfolio",
          payload,
        });
        return;
      }

      updateBudgetRequest({
        id: selectedRow.id,
        parentID: selectedRow.id,
        parent: "Budget",
        payload,
      });
    } else {
      if (projectID) {
        createBudgetRequest({
          parentID: projectID,
          parent: "Project",
          payload,
        });
        return;
      }
      if (programID) {
        createBudgetRequest({
          parentID: programID,
          parent: "Program",
          payload,
        });
        return;
      }
      if (portfolioID) {
        createBudgetRequest({
          parentID: portfolioID,
          parent: "Portfolio",
          payload,
        });
        return;
      }

      createBudgetRequest({ parent: "Budget", payload });
    }
  };

  const handleInputChange = (value, name) => {
    if (name === "name") setName(value);
  };

  useEffect(() => {
    if (error !== "") {
      error &&
        Object.keys(error).forEach((key) => {
          if (key === "Name") {
            setFormErrors((prevErrors) => ({
              ...prevErrors,
              name: error[key][0],
            }));
          }
        });
    } else {
      setFormErrors({});
    }
  }, [error]);

  useEffect(() => {
    if (name) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        name: "",
      }));
    }
    if (ProjectId) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        projectId: "",
      }));
      setStartDate(ProjectId.start);
      setEndDate(ProjectId.end);
    }
  }, [ProjectId, name]);

  useEffect(() => {
    if (projectID) {
      projectService
        .getProjectDetailsRequest({ id: projectID })
        .then((projectData) => {
          setStartDate(projectData.startDate);
          setEndDate(projectData.endDate);
        })
        .catch(() => { });
    }
  }, [projectID]);

  const fetchBudgetData = async () => {
    setIsLoading(true);
    service
      .fetchSingleBudgetRequest(selectedRow.id)
      .then((budgetData) => {
        setName(budgetData.name);
        if (parentType === "Project") {
          setCode(budgetData.cashflowLine.description);
        } else {
          setCode(budgetData.code);
        }
        setInitialBudgetCost(`${budgetData.initialBudgetCost}`);
        setInitialBudgetTime(`${budgetData.initialBudgetTime}`);
        setChangeRequest(budgetData.changeRequest)
        setChangeRequestsCost(`${budgetData.changeRequestsCost}`);
        setChangeRequestsTime(`${budgetData.changeRequestsTime}`);
        setPV(`${budgetData.pv}`);
        setActual(budgetData?.cashflowLine?.totalAc ?? 0);
        setEV(`${budgetData.ev}`);
        setETC(`${budgetData.etc}`);
        setSV(`${budgetData.sv}`);
        setInvoiced(budgetData?.cashflowLine?.totalInv ?? 0);
        setAccural(budgetData?.cashflowLine?.totalAccural ?? 0);
        budgetData.client
          ? setClientId({
            label: budgetData.client.name,
            value: budgetData.client.id,
          })
          : setClientId("");
        budgetData.portfolio
          ? setPortfolioId({
            label: budgetData.portfolio.name,
            value: budgetData.portfolio.id,
          })
          : setPortfolioId("");
        budgetData.program
          ? setProgramId({
            label: budgetData.program.name,
            value: budgetData.program.id,
          })
          : setProgramId("");
        budgetData.project
          ? setProjectId({
            label: budgetData.project.name,
            value: budgetData.project.id,
          })
          : setProjectId("");

        setForecastTotals({
          totalForecastAllocation: budgetData?.cashflowLine?.totalForecastAllocation,
          totalForecastHours: budgetData?.cashflowLine?.totalForecastHours,
          totalForecastHourlyCostRate: budgetData?.cashflowLine?.totalForecastHourlyCostRate,
          totalForecastHourlyBillRate: budgetData?.cashflowLine?.totalForecastHourlyBillRate,
          totalForecastCost: budgetData?.cashflowLine?.totalForecastCost,
          totalForecastBill: budgetData?.cashflowLine?.totalForecastBill,
          totalForecastCv: budgetData?.cashflowLine?.totalForecastCv,
          totalForecastHv: budgetData?.cashflowLine?.totalForecastHv,
        })
        setIsLoading(false);

      })
      .catch((error) => console.error("Error fetching data:", error));
  };

  const handleCancel = () => {
    setFormErrors({});
    setIsEdit(false);
    prevClientId = null;
    manualUpdate.current.client = false;
    manualUpdate.current.portfolio = false;
    manualUpdate.current.program = false;
  };

  useEffect(() => {
    if (Object.keys(selectedRow).length > 0) {
      isEdit && fetchBudgetData();
    } else {
      setClientId("");
      setPortfolioId("");
      setProgramId("");
      setProjectId("");
      setProjectOptions([]);
      setName("");
      setCode("");
      setInitialBudgetCost("");
      setInitialBudgetTime("");
      setChangeRequestsCost("");
      setChangeRequest(null);
      setChangeRequestsTime("");
      setPV("");
      setActual("");
      setEV("");
      setETC("");
      setSV("");
    }
  }, [selectedRow, isEdit]);

  const formBody = () => {
    return (
      <>
        {/* <InputUnderline
          placeholder="Enter description"
          value={name}
          error={formErrors.name}
          handleChange={(value) => handleInputChange(value, "name")}
          isRequired
          loading={isLoading}
        /> */}
        {/* <InputUnderline
          placeholder="Payment Code"
          value={code}
          handleChange={setCode}
          loading={isLoading}
          autoFocus={false}
          isReadOnly={true}
        /> */}
        <div className="w-100 mt-3">
          <label class="Input_label">Payment Code</label>
          {isLoading ? (
            <Skeleton
              height={40}
              baseColor="#e0e0e0"
              highlightColor="#ECE7FD"
            />
          ) : (
            <p
              style={{ border: "1px solid #342C82" }}
              className=" d-flex items-center justify-star px-[8px] text-[#1F1F1F] bg-[#EDECF8] text-center py-[4px] rounded-md h-[40px]"
            >
              {code}
            </p>
          )}
        </div>
        <div className="d-flex">
          {parentType !== "Client" &&
            overviewType !== "Portfolio" &&
            overviewType !== "Program" &&
            overviewType !== "Project" && (
              <div className="mt-4 w-50">
                <Searchable
                  label="Client"
                  SelectText="client"
                  selectWd="me-3"
                  searchText={searchClientHandler}
                  options={clientOptions}
                  defaultVal={ClientId}
                  onChange={(e) => {
                    setClientId(e);
                    setPortfolioId("");
                    setProgramId("");
                    setProjectId("");
                  }}
                  loading={isLoading}
                />
              </div>
            )}
          {overviewType !== "Portfolio" &&
            overviewType !== "Program" &&
            overviewType !== "Project" && (
              <div className="mt-4 w-50">
                <Searchable
                  label="Portfolio"
                  SelectText="portfolio"
                  selectWd="me-3"
                  searchText={searchPortfolioHandler}
                  options={portfolioOptions}
                  defaultVal={PortfolioId}
                  onChange={(e) => {
                    setPortfolioId(e);
                    setProgramId("");
                    setProjectId("");
                  }}
                  loading={isLoading}
                />
              </div>
            )}
        </div>
        <div className="d-flex">
          {overviewType !== "Program" && overviewType !== "Project" && (
            <div className="mt-4 w-50">
              <Searchable
                label="Program"
                SelectText="program"
                selectWd="me-3"
                searchText={searchProgramHandler}
                options={programOptions}
                defaultVal={ProgramId}
                onChange={(e) => {
                  setProgramId(e);
                  setProjectId("");
                }}
                loading={isLoading}
              />
            </div>
          )}
          {overviewType !== "Project" && (
            <div className="mt-4 w-50">
              <Searchable
                label="Project"
                SelectText="project"
                selectWd="me-3"
                searchText={searchProjectHandler}
                options={projectOptions}
                defaultVal={ProjectId}
                onChange={(e) => setProjectId(e)}
                errorMessage={formErrors.projectId}
                isRequired
                loading={isLoading}
              />
            </div>
          )}
        </div>
        {/* {!projectID && (
          <div className="mt-4 w-50">
            <Searchable
              label="Project"
              SelectText="project"
              selectWd="w-75 me-3"
              searchText={searchProjectHandler}
              options={projectOptions}
              defaultVal={ProjectId}
              onChange={(e) => setProjectId(e)}
              errorMessage={formErrors.projectId}
              isRequired
            />
          </div>
        )} */}
        <h5 className="mt-4 mb-3">Budget</h5>
        <div>
          <div className="d-flex align-items-start mb-3">
            <div className="w-50 me-3 d-flex align-items-end">
              <Input
                inputwd="w-75 me-2"
                value={`${initialBudgetCost}`}
                type="number"
                handleChange={setInitialBudgetCost}
                label="Initial Budget"
                currency={true}
                placeholder="0"
                // placeholder={`${getAccountCurrency()} 0`}
                loading={isLoading}
              />
              <Input
                inputwd="w-25"
                value={`${initialBudgetTime}`}
                type="number"
                handleChange={setInitialBudgetTime}
                label=""
                placeholder="days"
                loading={isLoading}
              />
            </div>
            <div className="w-50 d-flex align-items-end">
              <div className="w-75 me-2 position-relative">
                <label class="Input_label">Change Request</label>
                {changeRequest ?
                  isLoading ? (
                    <Skeleton
                      height={40}
                      width="w-75"
                      baseColor="#e0e0e0"
                      highlightColor="#ECE7FD"
                    />
                  )
                    :
                    <p
                      className=" text-[#1F1F1F] bg-[#EDECF8] text-center py-[9px] rounded-md me-2 Input_wrapper position-relative"
                      style={{ border: "1px solid #342C82" }}
                    >
                      {`${getAccountCurrency(setting)} ${displayDecimalFormatted(
                        setting,
                        Number(changeRequestsCost)
                      )}`}
                    </p>
                  :
                  <Input
                    value={`${changeRequestsCost}`}
                    type="number"
                    handleChange={setChangeRequestsCost}
                    currency={true}
                    placeholder="0"
                    // placeholder={`${getAccountCurrency()} 0`}
                    loading={isLoading}
                  />
                }
              </div>
              <Input
                inputwd="w-25"
                value={`${changeRequestsTime}`}
                type="number"
                handleChange={setChangeRequestsTime}
                label=""
                placeholder="days"
                loading={isLoading}
              />
            </div>
          </div>
          <div className="d-flex flex-col align-items-start mb-3">
            <label class="Input_label">Revised Budget</label>
            <div className="w-50 me-3 d-flex align-items-end">
              {isLoading ? (
                <Skeleton
                  height={40}
                  baseColor="#e0e0e0"
                  highlightColor="#ECE7FD"
                />
              ) : (
                <>
                  <p
                    className=" text-[#1F1F1F] bg-[#EDECF8] text-center py-[9px] rounded-md w-75 me-2"
                    style={{ border: "1px solid #342C82" }}
                  >
                    {`${getAccountCurrency(setting)} ${displayDecimalFormatted(
                      setting,
                      Number(initialBudgetCost) + Number(changeRequestsCost)
                    )}`}
                  </p>
                  <p
                    className=" text-[#1F1F1F] bg-[#EDECF8] text-center py-[9px] rounded-md w-25"
                    style={{ border: "1px solid #342C82" }}
                  >
                    {`${displayDecimalFormatted(setting, Number(initialBudgetTime) + Number(changeRequestsTime))}`}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
        <h5 className="mt-4 mb-3">Forecast</h5>
        <div className="row align-items-center mb-3 gx-3">
          <div className="col-3">
            <label className="Input_label">Total Allocation</label>
            {isLoading ? (
              <Skeleton height={40} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
            ) : (
              <p
                style={{ border: "1px solid #342C82" }}
                className="d-flex items-center justify-star px-[8px] text-[#1F1F1F] bg-[#EDECF8] text-center py-[4px] rounded-md h-[40px]"
              >
                {displayDecimalFormatted(
                  setting,
                  Number(forecastTotals.totalForecastAllocation) || 0
                )}
              </p>
            )}
          </div>

          <div className="col-3">
            <label className="Input_label">Total Hours</label>
            {isLoading ? (
              <Skeleton height={40} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
            ) : (
              <p
                style={{ border: "1px solid #342C82" }}
                className="d-flex items-center justify-star px-[8px] text-[#1F1F1F] bg-[#EDECF8] text-center py-[4px] rounded-md h-[40px]"
              >
                {displayDecimalFormatted(
                  setting,
                  Number(forecastTotals.totalForecastHours) || 0
                )}
              </p>
            )}
          </div>

          <div className="col-3">
            <label className="Input_label">Total Cost</label>
            {isLoading ? (
              <Skeleton height={40} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
            ) : (
              <p
                style={{ border: "1px solid #342C82" }}
                className="d-flex items-center justify-star px-[8px] text-[#1F1F1F] bg-[#EDECF8] text-center py-[4px] rounded-md h-[40px]"
              >
                {`${getAccountCurrency(setting)} ${displayDecimalFormatted(
                  setting,
                  Number(forecastTotals.totalForecastCost) || 0
                )}`}
              </p>
            )}
          </div>

          <div className="col-3">
            <label className="Input_label">Total Bill</label>
            {isLoading ? (
              <Skeleton height={40} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
            ) : (
              <p
                style={{ border: "1px solid #342C82" }}
                className="d-flex items-center justify-star px-[8px] text-[#1F1F1F] bg-[#EDECF8] text-center py-[4px] rounded-md h-[40px]"
              >
                {`${getAccountCurrency(setting)} ${displayDecimalFormatted(
                  setting,
                  Number(forecastTotals.totalForecastBill) || 0
                )}`}
              </p>
            )}
          </div>
        </div>
        <h5 className="mt-4 mb-3">Amounts</h5>
        <div>
          <div className="row align-items-center mb-3 gx-3">
            <div className="col-3">
              <label class="Input_label">Invoiced</label>
              {isLoading ? (
                <Skeleton
                  height={40}
                  baseColor="#e0e0e0"
                  highlightColor="#ECE7FD"
                />
              ) : (
                <p
                  style={{ border: "1px solid #342C82" }}
                  className=" d-flex items-center justify-star px-[8px] text-[#1F1F1F] bg-[#EDECF8] text-center py-[4px] rounded-md h-[40px]"
                >
                  {`${getAccountCurrency(setting)} ${displayDecimalFormatted(setting, Number(invoiced) || 0)}`}
                </p>
              )}
            </div>
            <div className="col-3">
              <label class="Input_label">Accural</label>
              {isLoading ? (
                <Skeleton
                  height={40}
                  baseColor="#e0e0e0"
                  highlightColor="#ECE7FD"
                />
              ) : (
                <p
                  style={{ border: "1px solid #342C82" }}
                  className=" d-flex items-center justify-star px-[8px] text-[#1F1F1F] bg-[#EDECF8] text-center py-[4px] rounded-md h-[40px]"
                >
                  {`${getAccountCurrency(setting)} ${displayDecimalFormatted(setting, Number(accural) || 0)}`}
                </p>
              )}
            </div>
            <div className="col-3">
              <label class="Input_label">Spent</label>
              {isLoading ? (
                <Skeleton
                  height={40}
                  baseColor="#e0e0e0"
                  highlightColor="#ECE7FD"
                />
              ) : (
                <p
                  style={{ border: "1px solid #342C82" }}
                  className={`d-flex items-center justify-star px-[8px] text-[#1F1F1F] bg-[#EDECF8] text-center py-[4px] rounded-md h-[40px]`}
                >
                  {`${getAccountCurrency(setting)} ${displayDecimalFormatted(
                    setting, Number(invoiced) + Number(accural)
                  )}`}
                </p>
              )}
            </div>
            <div className="col-3">
              <label class="Input_label">Actual</label>
              {isLoading ? (
                <Skeleton
                  height={40}
                  baseColor="#e0e0e0"
                  highlightColor="#ECE7FD"
                />
              ) : (
                <p
                  style={{ border: "1px solid #342C82" }}
                  className={`d-flex items-center justify-star px-[8px] text-[#1F1F1F] bg-[#EDECF8] text-center py-[4px] rounded-md h-[40px]`}
                >
                  {`${getAccountCurrency(setting)} ${displayDecimalFormatted(
                    setting, Number(actual) || 0
                  )}`}
                </p>
              )}
            </div>
          </div>
          <div className="row align-items-center mb-3 gx-3">
            <div className="col-3">
              <Input
                value={`${pv}`}
                type="number"
                handleChange={setPV}
                label="PV"
                currency={true}
                placeholder="0"
                // placeholder={`${getAccountCurrency()} 0`}
                loading={isLoading}
              />
            </div>
            <div className="col-3">
              <Input
                value={`${ev}`}
                type="number"
                handleChange={setEV}
                label="EV"
                currency={true}
                placeholder="0"
                // placeholder={`${getAccountCurrency()} 0`}
                loading={isLoading}
              />
            </div>
            <div className="col-3">
              <label class="Input_label">ETC</label>
              {isLoading ? (
                <Skeleton
                  height={40}
                  baseColor="#e0e0e0"
                  highlightColor="#ECE7FD"
                />
              ) :

                changeRequest ?
                  <p
                    className="d-flex items-center justify-star px-[8px] text-[#1F1F1F] bg-[#EDECF8] text-center py-[4px] rounded-md h-[40px]"
                    style={{ border: "1px solid #342C82" }}
                  >
                    {`${getAccountCurrency(setting)} ${displayDecimalFormatted(
                      setting,
                      Number(etc)
                    )}`}
                  </p>
                  :
                  <Input
                    value={`${etc}`}
                    type="number"
                    handleChange={setETC}
                    currency={true}
                    placeholder="0"
                    // placeholder={`${getAccountCurrency()} 0`}
                    loading={isLoading}
                  />
              }

            </div>
            <div className="col-3">
              <label class="Input_label">BAC</label>
              {isLoading ? (
                <Skeleton
                  height={40}
                  baseColor="#e0e0e0"
                  highlightColor="#ECE7FD"
                />
              ) : (
                (() => {
                  var revisedBudget = Number(initialBudgetCost) + Number(changeRequestsCost);
                  var bac = Number(invoiced) + Number(accural) + Number(etc);
                  const isOverBudget = revisedBudget < bac;
                  const bacStyle = isOverBudget
                    ? "bg-[#da3b01]"
                    : "bg-[#107c10]";
                  const displayValue = `${getAccountCurrency(
                    setting
                  )} ${displayDecimalFormatted(setting, bac || 0)}`;
                  return (
                    <p
                      style={{ border: "1px solid #342C82" }}
                      className={`d-flex items-center justify-star px-[8px] text-[#FFF] text-center py-[4px] rounded-md h-[40px] ${bacStyle}`}
                    >
                      {displayValue}
                    </p>
                  );
                })()
              )}
            </div>
          </div>
        </div>
        <h5 className="mt-4 mb-3">Calculated variances</h5>
        <div className="row align-items-center mb-3 gx-3">
          <div className="col-4">
            <label class="Input_label">Forecast CV</label>
            {isLoading ? (
              <Skeleton
                height={40}
                baseColor="#e0e0e0"
                highlightColor="#ECE7FD"
              />
            ) : (
              (() => {
                const forecastCvStyle = Number(forecastTotals.totalForecastCv) < 0 ? "bg-[#da3b01]" : "bg-[#107c10]";
                const displayValue = `${getAccountCurrency(setting)} ${displayDecimalFormatted(setting, forecastTotals.totalForecastCv || 0)}`;
                return (
                  <p
                    style={{ border: "1px solid #342C82" }}
                    className={`d-flex items-center justify-star px-[8px] text-[#FFF] text-center py-[4px] rounded-md h-[40px] ${forecastCvStyle}`}
                  >
                    {displayValue}
                  </p>
                );
              })()
            )}
          </div>
          <div className="col-4">
            <label class="Input_label">Forecast HV</label>
            {isLoading ? (
              <Skeleton
                height={40}
                baseColor="#e0e0e0"
                highlightColor="#ECE7FD"
              />
            ) : (
              (() => {
                const forecastHvStyle = Number(forecastTotals.totalForecastHv) < 0 ? "bg-[#da3b01]" : "bg-[#107c10]";
                const displayValue = `${displayDecimalFormatted(setting, forecastTotals.totalForecastHv || 0)}`;
                return (
                  <p
                    style={{ border: "1px solid #342C82" }}
                    className={`d-flex items-center justify-star px-[8px] text-[#FFF] text-center py-[4px] rounded-md h-[40px] ${forecastHvStyle}`}
                  >
                    {displayValue}
                  </p>
                );
              })()
            )}
          </div>
          <div className="col-4">
            <label class="Input_label">CV</label>
            {isLoading ? (
              <Skeleton
                height={40}
                baseColor="#e0e0e0"
                highlightColor="#ECE7FD"
              />
            ) : (
              (() => {
                var revisedBudget = Number(initialBudgetCost) + Number(changeRequestsCost);
                var bac = Number(invoiced) + Number(accural) + Number(etc);
                var cv = bac - revisedBudget;
                const isOverBudget = revisedBudget < bac;
                const cvStyle = isOverBudget ? "bg-[#da3b01]" : "bg-[#107c10]";
                const displayValue = `${getAccountCurrency(
                  setting
                )} ${displayDecimalFormatted(setting, cv || 0)}`;
                return (
                  <p
                    style={{ border: "1px solid #342C82" }}
                    className={`d-flex items-center justify-star px-[8px] text-[#FFF] text-center py-[4px] rounded-md h-[40px] ${cvStyle}`}
                  >
                    {displayValue}
                  </p>
                );
              })()
            )}
          </div>
          {/* <div className="col-4">
          <label class="Input_label">SV</label>
            {
              isLoading ?
              <Skeleton height={40} baseColor="#e0e0e0" highlightColor="#ECE7FD"/>:
              <p
                style={{ border: "1px solid #342C82" }}
                className={`d-flex items-center justify-star px-[8px] BlueFieldBg text-center py-[4px] rounded-md h-[40px]`}
              >
                {`${getAccountCurrency(setting)} ${displayDecimalFormatted(
                  setting,
                  sv
                )}`}
            }
          </div> */}
        </div>
        <RichTextEditor
          label="Description"
          content={name}
          onChange={(value) => handleInputChange(value, "name")}
          loading={isLoading}
        />
      </>
    );
  };

  useEffect(() => {
    fetchData();
  }, [pageNum, perPageItems]);

  const handleCancelAddRow = () => {
    setIsCreateNewRow(false);
    fetchData();
  };

  const handleSearch = (filteredData) => {
    setData(filteredData);
  };

  useEffect(() => {
    if (projectID) {
      setProjectId(projectID);
      setParentType("Project");
      setIsHeader(false);
    }
    if (programID) {
      setParentType("Program");
      setIsHeader(false);
    }

    if (portfolioID) {
      setParentType("Portfolio");
      setIsHeader(false);
    }
  }, [projectID, programID, portfolioID]);

  useEffect(() => {
    if (defaultProject && defaultProject.hasOwnProperty("name")) {
      setProjectId({
        label: defaultProject.name,
        value: defaultProject.id,
      });
    }
  }, [defaultProject]);

  useEffect(() => {
    if (defaultProgram && defaultProgram.hasOwnProperty("name")) {
      setProgramId({
        label: defaultProgram.name,
        value: defaultProgram.id,
      });
    }
  }, [defaultProgram]);

  useEffect(() => {
    if (defaultPortfolio && defaultPortfolio.hasOwnProperty("name")) {
      setPortfolioId({
        label: defaultPortfolio.name,
        value: defaultPortfolio.id,
      });
    }
  }, [defaultPortfolio]);

  useEffect(() => {
    if (ProjectId && !manualUpdate.current.program) {
      if (!ClientId && !PortfolioId && !ProgramId && !projectID) {
        projectService
          .getProjectDetailsRequest({
            id: typeof ProjectId === "string" ? ProjectId : ProjectId.value,
          })
          .then((projectData) => {
            manualUpdate.current.program = true;
            manualUpdate.current.portfolio = true;
            manualUpdate.current.client = true;

            projectData.client
              ? setClientId({
                label: projectData.client.name,
                value: projectData.client.id,
              })
              : setClientId("");
            projectData.portfolio
              ? setPortfolioId({
                label: projectData.portfolio.name,
                value: projectData.portfolio.id,
              })
              : setPortfolioId("");
            projectData.program
              ? setProgramId({
                label: projectData.program.name,
                value: projectData.program.id,
              })
              : setProgramId("");
          })
          .catch((error) =>
            console.error("Error fetching project data:", error)
          );
      }
    }
  }, [ProjectId]);

  useEffect(() => {
    if (!ProgramId && !isEdit) {
      setProjectId("");
    } else if (!ProgramId) {
      setProjectId("");
    }
    if (ProgramId && !manualUpdate.current.portfolio) {
      if (!ClientId && !PortfolioId) {
        programService
          .fetchProgramDataRequest({
            id: typeof ProgramId === "string" ? ProgramId : ProgramId.value,
          })
          .then((data) => {
            // Mark the next updates as manual to prevent cascading effects
            manualUpdate.current.portfolio = true;
            manualUpdate.current.client = true;

            // Update the state of the parent fields
            data.client
              ? setClientId({ label: data.client.name, value: data.client.id })
              : setClientId("");
            data.portfolio
              ? setPortfolioId({
                label: data.portfolio.name,
                value: data.portfolio.id,
              })
              : setPortfolioId("");
            setProjectId(""); // Clear ProjectId when ProgramId changes
          })
          .catch((error) =>
            console.error("Error fetching program data:", error)
          );
      } else {
        if (!isEdit) {
          setProjectId("");
        }
      }
    }
  }, [ProgramId]);

  useEffect(() => {
    if (!PortfolioId && !isEdit) {
      setProgramId("");
      setProjectId("");
    } else if (!PortfolioId) {
      setProgramId("");
      setProjectId("");
    }
    if (PortfolioId && !manualUpdate.current.client) {
      if (!ClientId) {
        portfolioService
          .getPortfolioDetails({
            id:
              typeof PortfolioId === "string" ? PortfolioId : PortfolioId.value,
          })
          .then((portfolioData) => {
            manualUpdate.current.client = true;
            portfolioData.client
              ? setClientId({
                label: portfolioData.client.name,
                value: portfolioData.client.id,
              })
              : setClientId("");
            setProgramId("");
            setProjectId("");
          })
          .catch((error) =>
            console.error("Error fetching portfolio data:", error)
          );
      } else {
        if (!isEdit) {
          setProgramId("");
          setProjectId("");
        }
      }
    }
  }, [PortfolioId]);

  useEffect(() => {
    if (!ClientId) {
      setPortfolioId("");
      setProgramId("");
      setProjectId("");
    }
    if (ClientId) {
      prevClientId.current = ClientId.value;
    }
    // if (ClientId && prevClientId.current === null) {
    //   prevClientId.current = ClientId.value;
    // }
    if (ClientId && prevClientId.current !== ClientId.value) {
      setPortfolioId("");
      setProgramId("");
      setProjectId("");
      prevClientId.current = ClientId.value;
    }
    manualUpdate.current.client = false;
    manualUpdate.current.portfolio = false;
    manualUpdate.current.program = false;
  }, [ClientId]);

  useEffect(() => {
    if (!hasProcessedRedirection && redirectionId) {
      setHasProcessedRedirection(true);
      setRedirectionItem({ id: redirectionId });

      if (onRedirectionComplete) {
        onRedirectionComplete();
      }
    }
  }, [redirectionId]);

  return (
    <ColumnConfigProvider
      tableName={parentType ? `${parentType}-Budget` : "Budget"}
    >
      <div className="listingScreen position-relative">
        {isHeader && (
          <div className="db_Subheader d-flex justify-content-between align-items-center mb-4">
            <h4>Budgets</h4>
            {/* {permissions?.includes("CostItem.Create") && (
              <Button
                btnClass="d_btn d_btn_primary"
                icon={<AddIconSvg />}
                label="Create Budget"
                clickHandler={handleCreate}
              />
            )} */}
          </div>
        )}

        <Table
          parentType={parentType}
          isHeader={isHeader}
          type={parentType === "Project" ? "BudgetCategory" : "Budget"}
          tableName={parentType === "Project" ? "BudgetCategory" : "Budget"}
          rows={data}
          body={formBody()}
          searchHandler={handleSearch}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          setPageNum={setPageNum}
          perPageItems={perPageItems}
          setIsCreate={setIsCreate}
          loading={pageLoading}
          modalLoading={loading}
          isCreate={isCreate}
          pagination={pagination}
          handleSave={() => handleSave()}
          handleDelete={(selectedRow) => handleDelete(selectedRow)}
          handleCancel={() => handleCancel()}
          setIsEdit={setIsEdit}
          setSelectedRow={setSelectedRow}
          portfolioId={portfolioID}
          programId={programID}
          projectId={projectID}
          handleAddRow={handleAddRow}
          handleCancelAddRow={handleCancelAddRow}
          setData={setData}
          isNoFixedHeight={isNoFixedHeight}
          forceShowEditModal={redirectionItem}
        />
      </div>
    </ColumnConfigProvider>
  );
};

export default Budget;
